import { useState } from 'react';
import colombiaMapService from '../../../services/ColombiaMapService';

export const useFilters = () => {
  const [daysFilter, setDaysFilter] = useState<string[]>([]);
  const [populationFilter, setPopulationFilter] = useState<string[]>([]);
  const [serviceFilter, setServiceFilter] = useState<string[]>([]);

  const setAllFiltersAndApply = (population: string[], services: string[], days: string[]) => {
    colombiaMapService.setPopulationFilter(population);
    colombiaMapService.setServiceFilter(services);
    colombiaMapService.setDaysFilter(days);
    colombiaMapService.recalcAndEmit();
  };

  const toggleIn = (arr: string[], value: string) =>
    arr.includes(value) ? arr.filter(v => v !== value) : [...arr, value];

  const selectPopulation = (name: string, onFilterApplied: () => void) => {
    setPopulationFilter(prev => {
      const next = toggleIn(prev, name);
      setAllFiltersAndApply(next, serviceFilter, daysFilter);
      onFilterApplied();
      return next;
    });
  };

  const selectService = (name: string, onFilterApplied: () => void) => {
    setServiceFilter(prev => {
      const next = toggleIn(prev, name);
      setAllFiltersAndApply(populationFilter, next, daysFilter);
      onFilterApplied();
      return next;
    });
  };

  const selectDays = (day: string, onFilterApplied: () => void) => {
    setDaysFilter(prev => {
      const next = toggleIn(prev, day);
      setAllFiltersAndApply(populationFilter, serviceFilter, next);
      onFilterApplied();
      return next;
    });
  };

  const clearFilters = (onFiltersCleared: () => void) => {
    setPopulationFilter([]);
    setServiceFilter([]);
    setDaysFilter([]);
    setAllFiltersAndApply([], [], []);
    onFiltersCleared();
  };

  const applyFilter = () => {
    // This function is called when manual filter application is needed
    setAllFiltersAndApply(populationFilter, serviceFilter, daysFilter);
  };

  return {
    daysFilter,
    populationFilter,
    serviceFilter,
    selectPopulation,
    selectService,
    selectDays,
    clearFilters,
    applyFilter,
  };
};
